var _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckmarkWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "25px",
    height: "25px",
    viewBox: "0 0 25 25",
    enableBackground: "new 0 0 25 25",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M22.812,12.5c0,5.695-4.617,10.311-10.312,10.311c-5.695,0-10.312-4.615-10.312-10.311 S6.805,2.188,12.5,2.188C18.194,2.188,22.812,6.805,22.812,12.5z M21.666,12.5c0-5.063-4.104-9.166-9.166-9.166 c-5.063,0-9.166,4.104-9.166,9.166s4.104,9.166,9.166,9.166C17.56,21.658,21.659,17.561,21.666,12.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M17.659,8.979c-0.076-0.314-0.321-0.584-0.623-0.684c-0.354-0.115-0.678-0.025-0.984,0.283 c-0.971,0.971-5.482,5.488-5.482,5.488s-1.99-1.988-2.44-2.439c-0.244-0.244-0.52-0.334-0.811-0.266 c-0.369,0.084-0.622,0.318-0.729,0.678c-0.099,0.328-0.003,0.641,0.282,0.928l3.034,3.029c0.196,0.195,0.43,0.299,0.678,0.299 c0.247,0,0.485-0.104,0.685-0.303c0.264-0.264,4.896-4.926,6.138-6.17C17.638,9.59,17.731,9.283,17.659,8.979z"
  })))))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckmarkWhite);
export default __webpack_public_path__ + "static/media/checkmark_white.b84ad2913bbc65559b72b3b5d9fb8b9e.svg";
export { ForwardRef as ReactComponent };